/* Bois Shop – interactions : animations, diaporama, carrousels, onglets, menu mobile,
   panier sans rechargement, recherche instantanée, compte à rebours, retour en haut */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var design = !!(window.Shopify && Shopify.designMode);
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }

  /* ----- Diaporama ----- */
  function initHero(root) {
    var slides = root.querySelectorAll('.bs-hero__slide');
    var dots = root.querySelectorAll('.bs-dots button');
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() {
      var delay = parseInt(root.dataset.speed || '6', 10) * 1000;
      clearInterval(timer);
      if (delay > 0) timer = setInterval(function () { go(i + 1); }, delay);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    play();
  }

  /* ----- Rangées défilantes ----- */
  function initRow(row) {
    if (row.dataset.bsReady) return;
    row.dataset.bsReady = 1;
    var track = row.querySelector('.bs-row__track');
    var prev = row.querySelector('.bs-arrow--prev');
    var next = row.querySelector('.bs-arrow--next');
    if (!track || !prev || !next) return;
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ----- Onglets de produits ----- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('.bs-tabs button');
    var panels = root.querySelectorAll('.bs-panel');
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.classList.toggle('is-active', j === k); x.setAttribute('aria-selected', j === k); });
        panels.forEach(function (p, j) {
          p.hidden = j !== k;
          if (j === k) p.animate && !reduce && p.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 350, easing: 'ease-out' });
        });
        var row = panels[k] && panels[k].querySelector('.bs-row__track');
        if (row) row.dispatchEvent(new Event('scroll'));
      });
    });
  }

  /* ----- Onglets du menu mobile (Menü / Kategorien) ----- */
  function initDrawerTabs(root) {
    var tabs = root.querySelectorAll('.bs-drawer__tabs [data-drawer-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var target = t.dataset.drawerTab;
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        root.querySelectorAll('[data-drawer-panel]').forEach(function (p) {
          var show = p.dataset.drawerPanel === target;
          p.hidden = !show;
          if (show && p.animate && !reduce) p.animate([{ opacity: 0, transform: 'translateX(8px)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: 'ease-out' });
        });
      });
    });
  }

  /* ----- Compte à rebours ----- */
  function initCount(el) {
    if (el.dataset.bsReady) return;
    el.dataset.bsReady = 1;
    var end = new Date(el.dataset.bsCountdown).getTime();
    if (isNaN(end)) return;
    var h;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; clearInterval(h); return; }
      el.hidden = false;
      var parts = [[Math.floor(s / 86400), 'jours'], [Math.floor(s % 86400 / 3600), 'h'], [Math.floor(s % 3600 / 60), 'min'], [s % 60, 's']];
      el.innerHTML = parts.map(function (p) { return '<span>' + pad(p[0]) + '<small>' + p[1] + '</small></span>'; }).join('');
    }
    tick();
    h = setInterval(tick, 1000);
  }

  /* ----- Apparition au défilement ----- */
  var REVEAL = '.bs-head, .bs-cat, .bs-deal, .bs-tabs, .bs-row, .bs-banner, .bs-promo, .bs-look, .bs-about > *, .bs-brand, .bs-post, .bs-feat, .bs-grid > .bs-card, .bs-shop__banner, .bs-toolbar, .bs-footer__main > *, [data-bs-reveal]';
  var io = null;
  if ('IntersectionObserver' in window && !design && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    document.documentElement.classList.add('js-bs');
  }
  function reveal(scope) {
    if (!io) return;
    var last = null, n = 0;
    scope.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('bs-reveal') || el.closest('.bs-hero, .bs-drawer, .bs-suggest')) return;
      if (el.parentElement !== last) { last = el.parentElement; n = 0; }
      el.style.setProperty('--bs-d', (Math.min(n, 6) * 0.08) + 's');
      n++;
      el.classList.add('bs-reveal');
      io.observe(el);
    });
  }

  /* ----- Panier sans rechargement ----- */
  function updateCartUI(cart) {
    document.querySelectorAll('.bs-cart__count').forEach(function (c) {
      c.textContent = cart.item_count;
      c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop');
    });
    document.querySelectorAll('.bs-cart .bs-actions__label').forEach(function (l) { l.textContent = money(cart.total_price); });
    document.querySelectorAll('.bs-cart').forEach(function (a) { a.setAttribute('aria-label', 'Panier (' + cart.item_count + ')'); });
  }
  function toast(html, isError) {
    var t = document.querySelector('.bs-toast');
    if (!t) { t = document.createElement('div'); t.className = 'bs-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.classList.toggle('bs-toast--err', !!isError);
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }
  function addToCart(form) {
    var btn = form.querySelector('[type=submit]') || document.querySelector('[form="' + form.id + '"][type=submit]');
    var btns = document.querySelectorAll('[form="' + form.id + '"][type=submit]');
    if (btn) btn.classList.add('is-loading');
    btns.forEach(function (b) { b.classList.add('is-loading'); });
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        var img = item.image ? '<img src="' + esc(item.image) + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '';
        toast(img + '<div><strong>✓ Ajouté au panier</strong>' + esc(item.product_title) + (item.quantity > 1 ? ' × ' + item.quantity : '') + '<br><a href="' + ROOT + 'cart">Voir le panier →</a></div>');
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCartUI(cart); document.dispatchEvent(new CustomEvent('bs:cart', { detail: cart })); })
      .catch(function (err) {
        toast('<div><strong>Impossible d\'ajouter ce produit</strong>' + esc((err && (err.description || err.message)) || 'Veuillez réessayer.') + '</div>', true);
      })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
        btns.forEach(function (b) { b.classList.remove('is-loading'); });
      });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('.bs-add, .bs-ajax-form')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    addToCart(f);
  });

  /* ----- Recherche instantanée ----- */
  function initSuggest(form) {
    if (form.dataset.bsReady) return;
    form.dataset.bsReady = 1;
    var input = form.querySelector('input[name=q]');
    if (!input) return;
    var box = document.createElement('div');
    box.className = 'bs-suggest';
    box.setAttribute('role', 'listbox');
    form.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    var timer, ctrl, sel = -1;
    function close() { box.classList.remove('is-on'); sel = -1; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection,article&resources[limit]=6';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
          var res = d.resources.results, h = '';
          if (res.collections && res.collections.length) {
            h += '<div class="bs-suggest__h">Kategorien</div>';
            res.collections.forEach(function (c) { h += '<a href="' + esc(c.url) + '"><span class="bs-suggest__t">' + esc(c.title) + '</span></a>'; });
          }
          if (res.articles && res.articles.length) {
            h += '<div class="bs-suggest__h">Ratgeber</div>';
            res.articles.forEach(function (a) { h += '<a href="' + esc(a.url) + '"><span class="bs-suggest__t">' + esc(a.title) + '</span></a>'; });
          }
          h += '<a class="bs-suggest__all" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last">Alle Ergebnisse für « ' + esc(q) + ' » anzeigen</a>';
          box.innerHTML = h;
          box.classList.add('is-on');
          sel = -1;
        }).catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) {
      var links = box.querySelectorAll('a');
      if (e.key === 'Escape') { close(); return; }
      if (!box.classList.contains('is-on') || !links.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach(function (l, k) { l.classList.toggle('is-sel', k === sel); });
      } else if (e.key === 'Enter' && sel > -1) {
        e.preventDefault();
        location.href = links[sel].href;
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  /* ----- Quantités +/- ----- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.bs-qty [data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = input.min === '' ? 1 : +input.min;
    input.value = Math.max(min, (+input.value || 0) + (+b.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Menu mobile et fermeture du menu catégories ----- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-bs-drawer-open]');
    var close = e.target.closest('[data-bs-drawer-close]');
    var drawer = document.querySelector('.bs-drawer');
    if (drawer && open) { drawer.setAttribute('open', ''); document.documentElement.style.overflow = 'hidden'; }
    if (drawer && close) { drawer.removeAttribute('open'); document.documentElement.style.overflow = ''; }
    if (!e.target.closest('.bs-cats')) {
      document.querySelectorAll('.bs-cats[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* ----- En-tête au défilement et retour en haut ----- */
  var header = null, topBtn = null, ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || 0;
      if (header) header.classList.toggle('is-scrolled', y > 30);
      if (topBtn) topBtn.classList.toggle('is-on', y > 700);
      ticking = false;
    });
  }
  function initChrome() {
    header = document.querySelector('.bs-header');
    if (!document.querySelector('.bs-top')) {
      topBtn = document.createElement('button');
      topBtn.type = 'button';
      topBtn.className = 'bs-top';
      topBtn.setAttribute('aria-label', 'Retour en haut');
      topBtn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg>';
      topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
      document.body.appendChild(topBtn);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-bs-hero]').forEach(initHero);
    scope.querySelectorAll('.bs-row').forEach(initRow);
    scope.querySelectorAll('[data-bs-tabs]').forEach(initTabs);
    scope.querySelectorAll('.bs-drawer').forEach(initDrawerTabs);
    scope.querySelectorAll('[data-bs-countdown]').forEach(initCount);
    scope.querySelectorAll('form.bs-search').forEach(initSuggest);
    reveal(scope);
  }

  window.BS = { init: init, money: money, esc: esc, toast: toast, updateCartUI: updateCartUI, addToCart: addToCart, root: ROOT };

  function start() { initChrome(); init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
